// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"702c8893","165":"f2ee259a","184":"0a28fc62","255":"025f2e72","323":"7b05bae9","407":"30a5361c","411":"bc479ca2","453":"f9c6d873","537":"879f70c5","587":"74ebc12f","596":"2042d221","639":"22e96a87","677":"4ac50205","762":"3df89ee1"}[chunkId] + ".chunk.js";
};